/* eslint-disable max-lines-per-function */
import { useMutation, useQuery } from "@apollo/client";
import css from "classnames";
import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Viewer } from "components/auth/types";
import { QUERY_SIDEBAR_FILTERS } from "pages/dashboard/interests/interests-sidebar/query";
import { PropertyStageSettings, ToggleStageSettings } from "types/gql-types";
import { useSnackbar } from "components/haven-design/snackbar";
import { QUERY_STAGE_SETTINGS, TOGGLE_STAGE_SETTINGS } from "./query";
import styles from "./settings.module.css";

type Props = {
  path: string;
  propertyId: string;
  listId: string;
  viewer: Viewer;
}

const Settings: React.FC<Props> = (props) => {
  const [toggle, result] = useMutation<ToggleStageSettings>(TOGGLE_STAGE_SETTINGS, {
    refetchQueries: [{ query: QUERY_SIDEBAR_FILTERS, variables: { interestListId: props.listId } }],
  });
  const query = useQuery<PropertyStageSettings>(QUERY_STAGE_SETTINGS, {
    variables: { id: props.propertyId },
    fetchPolicy: "network-only",
  });
  const { openSnackbar } = useSnackbar();

  if (query.error || query.loading || !query.data) return null;

  const {
    property: { stages },
  } = query.data;

  return (
    <>
      <div className={styles.description}>
        Supervisors can choose property statuses.
      </div>
      <div>
        {stages
          .filter((stage) => !stage.standard)
          .map((stage) => (
            <div key={stage.id}>
              <FormControlLabel
                className={css(styles.label, { [styles.inactive]: !stage.enabled })}
                classes={{ label: styles.name }}
                control={
                  <Checkbox
                    color="secondary"
                    className={styles.toggle}
                    checked={stage.enabled}
                    disabled={query.loading || result.loading || !props.viewer.isSupervisor}
                    onChange={async (_event, _checked) => {
                      const variables = {
                        property: props.propertyId,
                        stage: stage.name,
                        enabled: !stage.enabled,
                      };
                      const toggleResult = await toggle({ variables });
                      if (!toggleResult.data) return;

                      const {
                        togglePropertyStage: { isSuccess, reason },
                      } = toggleResult.data;

                      if (!isSuccess) {
                        openSnackbar({ message: reason, status: "error" });
                        return;
                      }

                      await query.refetch();
                    }}
                  />
                }
                label={stage.name}
              />
            </div>
          ))}
      </div>
    </>
  );
};

export default Settings;
